import { Reveal, MaskedLines } from "@/components/Reveal";
import { GALLERY } from "@/lib/site";

export default function Gallery() {
  return (
    <section className="bg-cream py-24 sm:py-32" data-testid="gallery-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <p className="eyebrow text-arc mb-6">Gallery</p>
        </Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <MaskedLines
            className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl"
            lines={[<>Craft, Detail</>, <>&amp; <span className="italic text-gradient">Light.</span></>]}
          />
          <Reveal delay={0.15}>
            <p className="max-w-md text-mist leading-relaxed">
              A look at the architecture, interiors and details that shape the homes we design —
              from façades and living spaces to plans under the pencil.
            </p>
          </Reveal>
        </div>

        <div className="masonry columns-2 md:columns-3 lg:columns-4 mt-14" data-testid="gallery-masonry-grid">
          {GALLERY.map((g, i) => (
            <figure
              key={i}
              className="relative overflow-hidden group cursor-pointer"
              data-testid={`gallery-item-${i + 1}`}
            >
              <img
                src={g.src}
                alt={`${g.label} — architectural imagery`}
                loading="lazy"
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-[1.2s] ease-out ${g.tall ? "aspect-[3/4]" : "aspect-square"}`}
              />
              <figcaption className="absolute inset-0 flex items-end bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream p-4">{g.label}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-xs text-mist/80" data-testid="gallery-imagery-disclaimer">
            Australian residential imagery via free commercial-licence sources (Unsplash / Pexels — no attribution required). ArcView Homes project photography coming soon.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
